import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTheme } from 'styled-components'
import close from 'assets/icons/close.svg'
import arrow from 'assets/icons/arrow.svg'
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'


const HeaderContainer = styled.div`
  background-color: var(--clr-bot-main, ${props => props.theme.primaryColor});
  border-radius: 7px 7px 0 0;
  color: ${props => props.theme.secondaryColor};
  display: flex;
  justify-content: flex-start;
  padding: 10px 15px;
  height: auto;
  align-items: center;

  @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px) {
    border-radius: 0;
    flex-shrink: 0;
    position: relative;
  }
`

const HeaderTextContainer = styled.div`
  flex-direction: column;
`

const HeaderTitle = styled.span`
  font-size: var(--headerFontSize);
`

const HeaderButton = styled.button`
  background: none;
  border: 0;
  display: block;
  width: 10px;
  margin-left: 5px;
  margin-right: 10px;
  cursor: pointer;
  padding: 0;

  & img {
    height: 30px;
    width: 30px;
    filter: ${props => props.theme.secondaryColor === '#fff' ? `invert(100%) sepia(6%) saturate(0%) hue-rotate(115deg) brightness(108%) contrast(108%)` : ''}
  }
  & .arrow {
    height: 18px;
    width: 18px;
  }
`

const Icon = styled.img`
  margin-right: 5px;
  width: 30px;
  height: 23px;
`

const Header = ({ title, subtitle, toggleChat, closeChat, theme, icon }) => {
  return (
    <HeaderContainer className="header" theme={theme}>
      {icon && <Icon src={icon} aria-label='header-icon' alt="header-icon" />}
      <HeaderTextContainer>
        <HeaderTitle aria-label={title} role="alert">
          {title}
        </HeaderTitle>
        <span>{subtitle}</span>
      </HeaderTextContainer>
      <div style={{display: 'flex', marginLeft: 'auto', alignItems: 'center' }}>
        {toggleChat && (
          <HeaderButton onClick={toggleChat} style={{marginRight: 20}}>
            <img src={arrow} aria-label='minimize chatbot' alt="minimize chatbot" className="arrow"/>
          </HeaderButton>
        )}
        <HeaderButton onClick={closeChat} style={{paddingTop: '5px'}}>
          <img src={close} aria-label='close chatbot' alt="close chatbot" />
        </HeaderButton>
      </div>
    </HeaderContainer>
  )}

Header.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  toggleChat: PropTypes.func.isRequired,
  closeChat: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
  }),
  icon: PropTypes.string,
}

export default withTheme(Header)



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Header/index.js